module.exports = __webpack_public_path__ + "img/GH-kyujin-top-osusume005.453be54a.webp";